import React, { useEffect, useState } from 'react'
import { components } from 'cng-web-lib'
import pathMap from '../../../paths/pathMap'
import UsProductMasterApiUrls from '../../../apiUrls/UsProductMasterApiUrls'
import withFormState from '../../../components/aciacehighway/hocs/withFormState'
import AlertDialog from '../../../components/aciacehighway/AlertDialog'
import FormProperties from './FormProperties'
import { Box, Card, Grid } from '@material-ui/core'
import { useFormContext } from 'react-hook-form'

const {
  button: { CngButton },
  form: { CngAddForm }
} = components

function AddPage(props) {
  const { history, location, onSetLoading, showNotification } = props

  return (
    <Card>
      <Box padding={2}>
        <CngAddForm
          fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
          history={history}
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap) => (
            <FormProperties.Fields
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          formikProps={{
            ...FormProperties.formikProps,
            initialValues: {
              ...FormProperties.formikProps.initialValues,
              ...location.state
            }
          }}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          create={{
            url: UsProductMasterApiUrls.POST,
            successRedirect: pathMap.US_PRODUCT_MASTER_LIST_VIEW
          }}
          renderButtonSection={(loading) => (
            <ButtonSection
              loading={loading}
              onDiscard={() => history.push(pathMap.US_PRODUCT_MASTER_LIST_VIEW)}
              onSetLoading={onSetLoading}
            />
          )}
        />
      </Box>
    </Card>
  )
}

function ButtonSection(props) {
  const { loading, onDiscard, onSetLoading } = props
  const [alertDialog, setAlertDialog] = useState(false)
  const {
    formState: { isSubmitting }
  } = useFormContext()

  useEffect(() => {
    onSetLoading(loading)
  }, [loading])

  return (
    <>
      <Grid container justify='space-between' spacing={3}>
        <Grid item xs='auto'>
          <CngButton
            color='secondary'
            disabled={isSubmitting}
            onClick={() => setAlertDialog(true)}
            size='medium'
          >
            Discard
          </CngButton>
        </Grid>
        <Grid item xs='auto'>
          <CngButton disabled={isSubmitting} type='submit' size='medium'>
            Save
          </CngButton>
        </Grid>
      </Grid>
      <AlertDialog
        cancelLabel='Continue editing'
        confirmLabel='Yes, discard'
        open={alertDialog}
        onClose={() => setAlertDialog(false)}
        onCancel={() => setAlertDialog(false)}
        onConfirm={onDiscard}
        title='Discard'
      >
        All progress in this session will be lost and can't be restored. Are you
        sure about this?
      </AlertDialog>
    </>
  )
}

export default withFormState(AddPage)
